export const REVIEWING_DOCUMENTS_STATUSES: string[] = [
  'EDOCS_SIGNED_TRACKING',
  'QA_HOLD',
  'RETURNED_BY_QA',
  'ARCHIVE',
];
